import React from "react";
import "./Spinner.scss";

const Spinner = ({ text }) => {
  return (
    <div className="spinner-container">
      <div className="spinner spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="spinner-text">{text || "Please wait ..."}</p>
    </div>
  );
};

export default Spinner;
